import React from 'react';
import { IIconProps } from './utils';

export const Checkmark = ({
  fill = 'currentColor', height = 24, width = 24, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M23.3839 10.8839C23.872 10.3957 23.872 9.60427 23.3839 9.11612C22.8957 8.62796 22.1043 8.62796 21.6161
      9.11612L12.5 18.2322L8.38388 14.1161C7.89573 13.628 7.10427 13.628 6.61612 14.1161C6.12796 14.6043 6.12796 15.3957
      6.61612 15.8839L11.6161 20.8839C12.1043 21.372 12.8957 21.372 13.3839 20.8839L23.3839 10.8839Z"
      fill={fill}
    />
  </svg>

);
